import React, { useState, useEffect } from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import showdown from 'showdown';
import Truncate from 'react-truncate';
const converter = new showdown.Converter()

const Item = ({
    name,
    desc,
    image,
}) => {
    return (
        <div
            className="px-3 to-scale-with-animation">
            <img
                src={image.image}
                alt={image.alt}
                className="img-fluid w-100" />
            <div
                style={{ height: "150px" }}
                className="bg-white p-3 mb-2">
                <div className="text-center font-weight-bold mb-3">
                    {name}
                </div>
                <div style={{height: "120px"}}>
                    <Truncate lines={3} ellipsis={<span>...</span>}>
                        <div 
                            className="text-muted"
                            dangerouslySetInnerHTML={{ __html: converter.makeHtml(desc) }} />
                    </Truncate>
                </div>
            </div>
        </div>
    )
}

const MAX_PER_SLIDE = 3;

const LandingSection1 = ({
    section1
}) => {
    const [slides, setSlides] = useState([]);

    useEffect(() => {
        let aux = [];
        const len = section1.items.length;
        if (len > 0) {
            const count = Math.ceil(len / MAX_PER_SLIDE);
            for (let index = 0; index < count; index++) {
                const prodSet = section1.items.slice(index * MAX_PER_SLIDE, (index + 1) * MAX_PER_SLIDE);
                aux.push(prodSet);
            }
        }
        setSlides(aux);
    }, [section1.items]);

    const {
        title
    } = section1;

    return (
        <section
            className="container-fluid bg-light py-5">
            <div className="container">
                <h3 className="font-weight-bold mb-3 text-center">{title}</h3>
                {/* displayed in desktpo */}
                <div className="d-none d-md-block">
                    <Carousel showStatus={false} showThumbs={false} emulateTouch>
                        {
                            slides.map((items, inde1) => (
                                <div
                                    key={`slide-${inde1}`}
                                    className="row">
                                    {
                                        items.map((item, index) => (
                                            <div
                                                // style={{ backgroundColor: "transparent" }}
                                                className={` ${index === 0 ? "offset-md-2" : ""} col-md-4 px-md-0 pb-5`}>
                                                <div
                                                    key={`prop${index}`}>
                                                    <Item
                                                        {...item}
                                                    />
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div>
                            ))
                        }
                    </Carousel>
                </div>

                {/* displayed in mobile */}
                <div className="d-block d-md-none">
                    <Carousel showStatus={false} showThumbs={false} emulateTouch>
                        {
                            section1.items.map((item, index) => (
                                <div
                                    // style={{ backgroundColor: "transparent" }}
                                    className="px-md-0 pb-5">
                                    <div
                                        key={`prop${index}`}>
                                        <Item
                                            {...item}
                                        />
                                    </div>
                                </div>
                            ))
                        }
                    </Carousel>
                </div>
            </div>
        </section>
    )
}

export default LandingSection1;